import React from 'react';
import { Project } from '../data/site';

type Props = {
  project: Project;
  compact?: boolean;
};

const hostLabel = (href: string) => href.replace(/^https?:\/\//, '').replace(/\/$/, '');

export const ProjectScene: React.FC<Props> = ({ project, compact }) => (
  <div className="scene">
    <div className={`browser ${compact ? 'is-compact' : ''}`}>
      <div className="browser-bar">
        <span className="browser-dot" />
        <span className="browser-dot" />
        <span className="browser-dot" />
        <span className="browser-url">{hostLabel(project.href)}</span>
      </div>
      <div className="browser-body">
        <a href={project.href} target="_blank" rel="noopener noreferrer">
          <img
            className="browser-shot"
            src={project.image}
            alt={
              project.store
                ? `${project.title} mağaza sayfası`
                : `${project.title} sitesinin gerçek görüntüsü`
            }
            loading="lazy"
          />
        </a>
      </div>
    </div>
  </div>
);
